import { PessoaFisica } from "../pessoa/pessoa.model";

export class Tecnico extends PessoaFisica {
    IdEquipe: number;
    IdEstado: number;
    PlacaCarro: string;
}



// WEBPACK FOOTER //
// ./src/app/tecnico/tecnico.model.ts